angular.module('routes.simulation.states.SimulationStatesPayloadResolver', [
  'stack'
])

/**
 * The SimulationStatesPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class SimulationStatesPayloadResolver
 * @constructor
 * @module routes.simulation.states.SimulationStatesPayloadResolver
 */
.factory('SimulationStatesPayloadResolver', [
  '$q',
  'GLOBAL',
  'ModelsService',
  function ($q, GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      if (params.stateId) {
        return ModelsService
          .get('states', GLOBAL.apiPath + '/states', { id: params.stateId })
          .then(function (response) {
            var queue = _(response.relatives)
             .filter({ model: 'decisions' })
             .map(function (relative) {
               return ModelsService
                .get(relative.model, GLOBAL.apiPath + '/' + relative.model, { id: relative.id });
             })
             .value();

            return $q.all(queue);
          });
      }
      return {};
    };
  }
]);
